document.querySelectorAll('[id^="Details-"] summary').forEach((summaryEl) => {
  summaryEl.setAttribute('role', 'button');
  summaryEl.setAttribute('aria-expanded', 'false');

  const contentEl = summaryEl.nextElementSibling;
  const parentDetailsEl = summaryEl.closest('details');

  if (contentEl) {
    if(contentEl.getAttribute('id')) {
      summaryEl.setAttribute('aria-controls', contentEl.id);
    }
    summaryEl.addEventListener('click', () => {
      summaryEl.setAttribute('aria-expanded', !parentDetailsEl.hasAttribute('open'));
    });
  }
});

document.querySelectorAll('[id^="Details-"] .details-close').forEach((closeEl) => {
  closeEl.setAttribute('role', 'button');
  closeEl.addEventListener('click', () => {
    const parentDetailsEl = closeEl.closest('[id^="Details-"][open]');
    parentDetailsEl.removeAttribute('open');
    parentDetailsEl.setAttribute('aria-expanded', 'false');
  });
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.section;
    this.section = document.getElementById(`shopify-section-${this.sectionId}`);
    this.addEventListener('change', this.onVariantChange);
    this.cachedFetch = [];
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    this.removeErrorMessage();

    if (this.currentVariant) {
      this.updateURL();
      this.renderPage();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  getSections() {
    return [
      {
        section: this.sectionId,
      }
    ]
  }

  renderPrice(html) {
    document.querySelector('.product-price').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-price').innerHTML;
  }

  renderEstimatedDelivery(html) {
    const estimatedDeliveryEl = document.querySelector('.product-cta-eta');
    if (estimatedDeliveryEl) {
      estimatedDeliveryEl.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-cta-eta').innerHTML;
    }
  }

  renderVariantInputs(html) {
    document.querySelector('.product-variant-inputs').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-variant-inputs').innerHTML;
  }

  renderProductForms(html) {
    const currentQuantityValue = document.querySelector('.product-form-container input[name="quantity"]')?.value;  
    document.querySelector('.product-form-container').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-form-container').innerHTML;
    document.querySelector('.product-form-mini-container').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-form-mini-container').innerHTML;
    if (currentQuantityValue) {
      document.querySelector('.product-form-container input[name="quantity"]').value = currentQuantityValue;
      document.querySelector('.product-form-mini-container input[name="quantity"]').value = currentQuantityValue;
    }
  }

  renderMedia(html) {
    document.querySelector('.product-medias').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-medias').innerHTML;
    const productBigGalleryEl = document.querySelector('.product-medias product-big-gallery');
    if (productBigGalleryEl) {
      productBigGalleryEl.goToVariantImage();
    }
  }

  renderReloadElements(html) {
    const reloadEls = this.section.querySelectorAll('.product-form-reload[id]');
    for (let i = 0; i < reloadEls.length; i++) {
      const reloadEl = reloadEls[i];
      const reloadId = reloadEl.id;
      reloadEl.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector(`#${reloadId}`).innerHTML;
    }
  }

  renderSectionWithHtml(html) {
    this.renderPrice(html);
    this.renderVariantInputs(html);
    this.renderProductForms(html);
    this.renderMedia(html);
    this.renderEstimatedDelivery(html);
    this.renderReloadElements(html);
  }

  renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.cachedFetch = [...this.cachedFetch, { html, url }];
        this.renderSectionWithHtml(html);
      });
  }

  renderSectionFromCache(url) {
    const html = this.cachedFetch.find((element) => element.url === url).html;
    this.renderSectionWithHtml(html);
  }

  renderPage() {
    const sections = this.getSections();

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&variant=${this.currentVariant.id}`;

      this.cachedFetch.some((element) => element.url === url) ?
        this.renderSectionFromCache(url) :
        this.renderSectionFromFetch(url);
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class SyncInput extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onInputChange);
  }

  onInputChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    document.querySelectorAll(`input[name="${name}"]`).forEach((input) => {
      input.value = value;
    });
  }
}

customElements.define('sync-input', SyncInput);

class ProductFormMini extends HTMLElement {
  constructor() {
    super();
    const containerEl = document.getElementById(this.dataset.containerId);
    if (!containerEl) return;
    const stickyParent = this.closest('h-sticky-add-to-cart');
    if (stickyParent && window.matchMedia('(min-width: 1024px)').matches) {
      const syncDisplay = () => {
        this.style.display = stickyParent.classList.contains('show') && !stickyParent.classList.contains('hide') ? 'block' : 'none';
      };
      const mo = new MutationObserver(syncDisplay);
      mo.observe(stickyParent, { attributes: true, attributeFilter: ['class'] });
      syncDisplay();
      return;
    }
    const triggerElObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          this.style.display = 'none';
        } else {
          if (entry.boundingClientRect.top > 0) return;
          this.style.display = 'block';
        }
      });
    });
    triggerElObserver.observe(containerEl);
  }
}

customElements.define('product-form-mini', ProductFormMini);
